import { Slider } from "antd";
import React, { useState } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { HiDotsVertical } from "react-icons/hi";
import { IoCloseCircle } from "react-icons/io5";
import agent from "../assets/img/Agent.jpg";
import img3 from "../assets/img/Funding.jpg";
import Investors from "../assets/img/Investors.jpg";
import img1 from "../assets/img/Start Repair.jpg";
import img2 from "../assets/img/Tutorials.jpg";
import Experian from "../assets/img/logo/ex.png";
import Equifax from "../assets/img/logo/eq.png";
import TransUnion from "../assets/img/logo/tr.png";

function Dashboard() {
  const cardData = [
    { title: "Start Repair", img: img1 },
    { title: "Tutorials", img: img2 },
    { title: "Funding", img: img3 },
  ];

  const disputes = [
    { name: Experian, count: 10 },
    { name: Equifax, count: 10 },
    { name: TransUnion, count: 10 },
  ];

  const [inputValue, setInputValue] = useState(1);
  const maxValue = 850;

  const onChange = (newValue) => setInputValue(newValue);

  const totalDisputes = disputes.reduce((total, item) => total + item.count, 0);

  return (
    <section className="dashboard page_overflow progress_page">
      <div className="container">
        <div className="section_title">
          <h1>Dashboard</h1>
        </div>

        <div className="file_upload_popup">
          <div className="left_area">
            <FaExclamationTriangle className="icons red" />
            <p className="mb-0">Upload your credit report here</p>
          </div>
          <IoCloseCircle className="icons" />
        </div>

        {/* Dashboard Content */}
        <div className="row">
          <p className="mb-1">
            "Good credit is the foundation of financial freedom & unlimited wealth potential."
          </p>

          {/* Left Column with Cards */}
          <div className="col-lg-8 col-md-12">
            <div className="row">
              {cardData.map((card, index) => (
                <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                  <div className="card">
                    <img className="img_area" src={card.img} alt={card.title} />
                    <h3>{card.title}</h3>
                  </div>
                </div>
              ))}

              <div className="col-md-12">
                <div className="card">
                  <img className="img_area" src={Investors} alt="Investors" />
                  <h3>Connect with Investors</h3>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column with Agent and Credit Score */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="card">
              <img className="img_area agent" src={agent} alt="Agent" />
              <h3>Chat with your Credit Repair Agent</h3>
            </div>

            {/* Credit Score Card */}
            <div className="card credit_score_cards">
              <div className="header_area">
                <h3>Today</h3>
                <HiDotsVertical className="icons dot-icon" />
              </div>
              <div>
                <div className="ex-title">
                  <h1>739</h1>
                  <button className="btn">
                    <p>VERY GOOD</p>
                  </button>
                </div>
                <div className="das_slider_header">
                  <p>FicoScore 8</p>
                  <p>Recently Updated</p>
                </div>

                {/* Slider with Numeric Value */}
                <div className="slide_progress_bar">
                  <Slider
                    min={0}
                    max={maxValue}
                    onChange={onChange}
                    value={inputValue}
                  />
                  <div className="bar_header mt-3">
                    <p>{inputValue}</p> {/* Displaying numeric value */}
                    <p>{maxValue}</p>
                  </div>
                </div>
              </div>

              {/* Dispute List */}
              <ul className="dispute_list mt-3">
                {disputes.map((dispute, index) => (
                  <li key={index}>
                    <img className="mask-image" src={dispute.name} alt="" />
                    <h2>{dispute.count}</h2>
                  </li>
                ))}
              </ul>

              {/* Total Disputes */}
              <ul className="total">
                <li>
                  <h3>Total:</h3>
                  <h1>{Math.round(totalDisputes)}</h1>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Start Credit Business Section */}
        <div className="start_credit_box">
          <h4>Start your credit repair business now!</h4>
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
